module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    style: ([_vm.footStyleHeight, _vm.footerLineHeight, _vm.headFooterStyle])
  }, [_vm._t("default", [_c('div', {
    style: (_vm.signature1Style1)
  }, [_vm._v(_vm._s(_vm.individuationSetting.signature1))]), _vm._v(" "), (_vm.individuationSetting.signature2) ? _c('div', {
    style: (_vm.signature1Style2)
  }, [_vm._v(_vm._s(_vm.individuationSetting.signature2))]) : _vm._e()])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1d8f9330", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1d8f9330"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/footer.vue
// module id = 1059
// module chunks = 1